export const dashboardRoles = ["admin", "editor", "viewer"] as const

export type DashboardRole = (typeof dashboardRoles)[number]

export type AuthUser = {
  sub?: string
  dashboardLanguage?: "en" | "ja"
  email?: string
  name?: string
  profileImageUrl?: string
  username?: string
  user_metadata?: {
    role?: unknown
    roles?: unknown
  }
  [claim: string]: unknown
}

export function isDashboardRole(value: unknown): value is DashboardRole {
  return dashboardRoles.includes(value as DashboardRole)
}

export function getUserRoles(user: AuthUser | null | undefined): DashboardRole[] {
  if (!user) return []
  const values = [user.user_metadata?.role, user.user_metadata?.roles].flatMap((value) => {
    if (Array.isArray(value)) return value
    return value ? [value] : []
  })
  return Array.from(new Set(values.filter(isDashboardRole)))
}

export function hasDashboardRole(user: AuthUser | null | undefined, roles: DashboardRole[]): boolean {
  if (roles.length === 0) return Boolean(user)
  const userRoles = getUserRoles(user)
  return roles.some((role) => userRoles.includes(role))
}

export function canEditContent(user: AuthUser | null | undefined): boolean {
  return hasDashboardRole(user, ["admin", "editor"])
}

export function canAdminDashboard(user: AuthUser | null | undefined): boolean {
  return hasDashboardRole(user, ["admin"])
}
